export const KIOSK_PAYMENT_TYPES = {
  creditCard: "creditCard",
  mobileWallet: "mobileWallet",
  ticketTender: "loaded_ticket"
}
